import { render, staticRenderFns } from "./BCXUserBadges.vue?vue&type=template&id=26c5055e"
import script from "./BCXUserBadges.vue?vue&type=script&lang=ts"
export * from "./BCXUserBadges.vue?vue&type=script&lang=ts"
import style0 from "./BCXUserBadges.vue?vue&type=style&index=0&id=26c5055e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports